var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgJournalistLogoTechCrunch = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 68 64",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M1.005 15.91h33.05v10.727H23.04v21.454H12.022V26.637H1.005V15.91Zm44.067 10.727H34.055v21.454h33.05V37.364H45.073V26.637Zm0-10.727v10.727h22.034V15.91H45.072Z"
})));
export default SvgJournalistLogoTechCrunch;